import React, { useState, useEffect } from "react";
import styles from './dwn-style.module.css';
import VideoPlayer from "./VideoPlayer";
import { useLocation, useNavigate } from 'react-router-dom';

const Meeting = () => {
  const [turnKey, setTurnKey] = useState("")
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isMicOn, setIsMicOn] = useState(true);
  const [isVideoOn, setIsVideoOn] = useState(true);
  const [access, setAccess] = useState(-1);
  const [chatInput, setChatInput] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);
  const [isPiP, setIsPiP] = useState(false);



  const [chatMessages, setChatMessages] = useState([
    { sender: "Remote Person", message: "Hello!" },
    { sender: "You", message: "Hi there!" },
  ]);

  const location = useLocation();
  const navigate = useNavigate();

  const pid = location?.state?.pid;
  const meeting_id = location?.state?.meeting_id;
  const uid = location?.state?.uid+"-portal";
  const role = location?.state?.role;
  const other_uid = location?.state?.other_uid;
  // Handlers
  const toggleChat = () => setIsChatOpen(!isChatOpen);

  const toggleMic = () => {
    setIsMicOn((prevState) => {
      const newMicState = !prevState;
      const micEvent = new CustomEvent("toggle-mic", {
        detail: { uid, meeting_id, micOn: newMicState },
      });
      window.dispatchEvent(micEvent);
      return newMicState;
    });
  };

  const toggleVideo = () => {
    setIsVideoOn((prevState) => {
      const newVideoState = !prevState;
      const videoEvent = new CustomEvent("toggle-video", {
        detail: { uid, meeting_id, videoOn: newVideoState },
      });
      window.dispatchEvent(videoEvent);
      return newVideoState;
    });
  };

  const sendMessage = () => {
    if (chatInput.trim() === "") return;
    const newMessage = { sender: "You", message: chatInput.trim() };
    setChatMessages((prevMessages) => [...prevMessages, newMessage]);
    const chatEvent = new CustomEvent("new-chat", {
      detail: { uid, meeting_id, message: chatInput.trim() },
    });
    window.dispatchEvent(chatEvent);
    setChatInput("");
  };

  const handleLeaveClick = () => {
    setShowModal(true);
  };

  const confirmLeaveMeeting = () => {
    const event = new CustomEvent("leave-meeting", { detail: { uid, meeting_id, role } });
    window.dispatchEvent(event);
    alert("You have left the meeting.");
  };

  const confirmEndMeeting = () => {
    const event = new CustomEvent("end-meeting", { detail: { uid, meeting_id, role } });
    window.dispatchEvent(event);
    alert("Meeting ended for all participants.");
  };

  const toggleScreenShare = () => {
    if (isScreenSharing) {
      stopScreenShare();
    } else {
      shareScreen();
    }
    setIsScreenSharing((prev) => !prev);
  };


  const shareScreen = () => {
    const event = new CustomEvent("share-screen");
    window.dispatchEvent(event);
  }


  const stopScreenShare = () => {
    const event = new CustomEvent("stop-sharing");
    window.dispatchEvent(event);    
  }



  const togglePiP = () => {
    setIsPiP((prev) => !prev);
    const event = new CustomEvent("PiP");
    window.dispatchEvent(event);   

  };


  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    setIsDesktop(!isMobile);
    if (isMobile) {
      alert("Tap the icons below to mute, disable video, or share screen.");
    }

  }, []);


  useEffect(() => {
    alert("This meeting is being recorded .");
  }, []);
  

  useEffect(() => {
    if (!pid) {
      navigate("/");
      return;
    }

    const fetchTurnKey = async () => {
      try {
        const response = await fetch("https://app.digitalwellnessnurse.com/api/portal/getTurnKey", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({type:"Turn"}),
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const data = await response.json();
        return data.key;
      } catch (error) {
        throw error;
      }
    };

    const verifyAccess = async () => {
      try {
        const response = await fetch("https://app.digitalwellnessnurse.com/api/portal/verify", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ username: pid, scope: "participant" }),
        });

        if (response.status !== 200) navigate("/");

        else if (response.status  == 200) {
           setTurnKey(await fetchTurnKey())
        }

        setAccess(response.status);

      } catch (err) {
        navigate("/");
      }
    };

    verifyAccess();
  }, [pid, navigate]);

  if (access === -1) {
    return (
      <div className={styles.center}>
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="meeting-container">
      <div className="video-section">
        <VideoPlayer uid={uid} meeting_id={meeting_id} turnKey={turnKey} role={role}/>
        <div className="controls">
            <button onClick={handleLeaveClick} className="leave-button">
              Leave Meeting
            </button>
            {showModal && (
                <div className="modal-overlay">
                  <div className="modal">
                    <h2>Leave Meeting</h2>
                    <p>Do you want to leave the meeting or end it for everyone?</p>
                    <div className="modal-actions">
                      <button onClick={confirmLeaveMeeting} className="btn-secondary">
                        Just Leave
                      </button>
                      <button onClick={confirmEndMeeting} className="btn-primary">
                        End Meeting for All
                      </button>
                    </div>
                    <button onClick={() => setShowModal(false)} className="close-btn">×</button>
                  </div>
                </div>
              )}
            <button className="button" onClick={toggleMic}>
            <img
              src={isMicOn ? "unmute.svg" : "mute.svg"}
              alt={isMicOn ? "Unmute Microphone" : "Mute Microphone"}
              className="icon"
            />
            {isMicOn ? "Mute" : "Unmute"}
          </button>
          <button
            className={`button ${isVideoOn ? "video-on" : "video-off"}`}
            onClick={toggleVideo}
          >
            <img
              src={isVideoOn ? "video_on.svg" : "video_off.svg"}
              alt={isVideoOn ? "Video On" : "Video Off"}
              className="icon"
            />
            {isVideoOn ? "Video Off" : "Video On"}
          </button>
          {isDesktop && (
            <button onClick={toggleScreenShare}>
              <img
                src={isScreenSharing ? "stop_share.svg" : "share.svg"}
                alt={isScreenSharing ? "Stop Sharing" : "Share Screen"}
                className="icon"
              />
              {isScreenSharing ? "Stop Sharing" : "Share Screen"}
            </button>
          )}
          <button onClick={togglePiP} className={styles.pipButton}>
            {isPiP ? 'Exit PiP' : 'Pop Out Video'}
        </button>
        </div>
      </div>


      {isChatOpen && (
        <div className="chat-panel">
          <h3>Chat</h3>
          <div className="chat-content">
            <div className="chat-messages">
              {chatMessages.map((msg, index) => (
                <p key={index}>
                  <strong>{msg.sender}:</strong> {msg.message}
                </p>
              ))}
            </div>
            <div className="chat-input-container">
              <input
                type="text"
                placeholder="Type a message..."
                className="chat-input"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
              />
              <button className="send-button" onClick={sendMessage}>
                Send
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Meeting;
